
//系统目录 / 药品剂型 接口相关的函数
import request from "../../untils/request.js"

//分页
export const getYbDataPage = (params) => {
    return request.get("/outpatient/insurance/page",{params})
}

export default{
}